import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import type { CompanyAnalysisCompetititorItem } from "app/pages/sales-intelligence/modules/company-analysis/types/competitors";

import * as ac from "./action-creators";

export type CompanyAnalysisCompetitorsState = {
    isRowSelectionEnabled: boolean;
    selectedRows: ReadonlyArray<CompanyAnalysisCompetititorItem & { key: React.Key }>;
    filteredRows: ReadonlyArray<CompanyAnalysisCompetititorItem>;
};

const INITIAL_COMPANY_COMPETITORS_STATE: CompanyAnalysisCompetitorsState = {
    isRowSelectionEnabled: false,
    selectedRows: [],
    filteredRows: [],
};

const companyAnalysisCompetitorsReducer = createReducer<CompanyAnalysisCompetitorsState, ActionType<typeof ac>>(
    INITIAL_COMPANY_COMPETITORS_STATE,
)
    .handleAction(
        ac.tableRowsSelectionToggledAction,
        (state, { payload }): CompanyAnalysisCompetitorsState => ({
            ...state,
            isRowSelectionEnabled: payload,
        }),
    )
    .handleAction(
        ac.setSelectedRowsAction,
        (state, { payload }): CompanyAnalysisCompetitorsState => ({
            ...state,
            selectedRows: payload,
        }),
    )
    .handleAction(
        ac.setFilteredRowsAction,
        (state, { payload }): CompanyAnalysisCompetitorsState => ({
            ...state,
            filteredRows: payload,
        }),
    );

export default companyAnalysisCompetitorsReducer;
